import { bannerStyle, closeButton, iconStyle, messageStyle } from '@components/Banner25/Banner25.css';
import { faTimesCircle } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import closeIcon from '@public/img/cross.svg';
import Image from 'next/image';

interface Banner25Props {
  type: 'negative';
  size: 'large';
  message: string;
  onClose?: () => void;
  dismissable: boolean;
  /** button not yet implemented */
  button?: false;
}

const bannerIconMap: Record<Banner25Props['type'], any> = {
  negative: faTimesCircle,
};

export const Banner25: React.FC<React.PropsWithChildren<Banner25Props>> = ({
  type,
  message,
  onClose,
  size,
  dismissable = false,
  button = false,
}) => {
  return (
    <div className={bannerStyle({ type, size })}>
      <FontAwesomeIcon className={iconStyle} icon={bannerIconMap[type]} />
      <span className={messageStyle({ size })}>{message}</span>
      {dismissable && (
        <button className={closeButton} onClick={onClose}>
          <Image src={closeIcon} alt="Close" />
        </button>
      )}
    </div>
  );
};
